var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html, css, LitElement } from "lit";
import { property, query } from "lit/decorators.js";
import { styleMap } from "lit/directives/style-map.js";
export class A2kDesktop extends LitElement {
    constructor() {
        super(...arguments);
        this.slotHeightStyles = {
            height: "0px",
        };
    }
    firstUpdated() {
        const containerHeight = getComputedStyle(this.desktopContainer).height;
        this.slotHeightStyles = { height: containerHeight };
    }
    render() {
        return html `<div id="desktop">
      <slot id="slot" style=${styleMap(this.slotHeightStyles)}></slot>
    </div>`;
    }
}
A2kDesktop.styles = css `
    #desktop {
      height: 100%;
    }

    #desktop > slot {
      display: flex;
      flex-flow: column wrap;
      width: fit-content;
    }
  `;
__decorate([
    property(),
    __metadata("design:type", Object)
], A2kDesktop.prototype, "slotHeightStyles", void 0);
__decorate([
    query("#desktop"),
    __metadata("design:type", HTMLSlotElement)
], A2kDesktop.prototype, "desktopContainer", void 0);
